import React from 'react'
import { GeneralSavings } from 'src/components/GeneralSavings/GeneralSavings'
import SEO from 'src/seo'
const GeneralSavingsPage = () => {
  return (
    <div>
      <SEO title="General Savings" />
      <GeneralSavings />
    </div>
  )
}

export { GeneralSavingsPage }
